module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-15db2f7f388c0b045c506696ecf05fb8.png";